import { DiffItem } from '../../coaching-base/diff-decorator';
import {
    ApprovalItem,
    EventParticipantDetail,
} from '../../coaching-base/general';
import { NoteDetailFormValue } from '../../coaching-note/note-detail-form-value.model';

export interface CommitmentSummaryDialogData {
    summaryView?: CommitmentSummaryViewMode;
    state?: ApprovalItem[];
    data?: DiffItem[];
    from?: EventParticipantDetail;
    signOff?: () => void;
}

export enum CommitmentSummaryViewMode {
    SENDER_VIEW,
    RECEIVER_VIEW,
    DISPUTE_VIEW,
    COMMITMENT_UPDATED_RESULT_VIEW,
}
export enum CommitmentSummaryDialogResultAction {
    SEND_FOR_APPROVAL,
    SEND_SIGN_OFF,
}

export interface CommitmentSummaryDialogResult {
    action?: CommitmentSummaryDialogResultAction;
    items?: ApprovalItem[];
}
export interface DiffItemFormValue {
    approved?: boolean;
    comment?: NoteDetailFormValue;
}
